import { toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-5a1efc4b")

_pushScopeId("data-v-5a1efc4b")
const _hoisted_1 = {
  id: "header",
  class: "w-full flex flex-wrap flex-col text-gray-100 font-bold"
}
const _hoisted_2 = { class: "w-full py-3 px-4 mt-10 flex flex-wrap items-center justify-between flex-row relative" }
const _hoisted_3 = {
  id: "points",
  class: "relative leading-4 italic rounded-full w-auto h-10 px-3"
}
const _hoisted_4 = { class: "w-full h-full rounded-full z-10 relative flex items-center justify-center" }
const _hoisted_5 = { class: "timer flex-1 text-xl text-center pt-2 absolute left-1/2" }
const _hoisted_6 = {
  id: "lives",
  class: "flex flex-row justify-evenly items-center w-16 h-10 pr-2 pl-1 rounded-full"
}
const _hoisted_7 = { class: "" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_progress_bar = _resolveComponent("progress-bar")
  const _component_heart = _resolveComponent("heart")

  return (_openBlock(), _createBlock("header", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        _createVNode("div", _hoisted_4, _toDisplayString(_ctx.points) + " xp ", 1)
      ]),
      _createVNode("div", _hoisted_5, [
        _createVNode(_component_progress_bar, {
          progress: _ctx.percentile,
          display: _ctx.display
        }, null, 8, ["progress", "display"])
      ]),
      _createVNode("div", _hoisted_6, [
        _createVNode(_component_heart, { id: "heart" }),
        _createVNode("span", _hoisted_7, _toDisplayString(_ctx.currentLives), 1)
      ])
    ])
  ]))
})